<div class="loading-screen">
  <div class="spinner"></div>
  <p>{{ loadingMessage() }}</p>
</div>
